document.addEventListener('DOMContentLoaded', () => {
  const scrollTargetLinks = document.querySelectorAll('[data-scroll-target]');

  scrollTargetLinks.forEach((scrollTargetLink) => {
    // On click, scroll to target
    scrollTargetLink.addEventListener('click', (e) => {
      e.preventDefault();
      const { scrollTarget } = e.currentTarget.dataset;

      document.getElementById(scrollTarget).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  });
});
